module.exports = __webpack_public_path__ + "assets/img/title-a1d1dcb0.png";